import { ComponentType, IConfig } from '../../types';
import {
  BASIC_JSON_LOGIC_TOOLTIP,
  BASIC_TANSLATE_TOOLTIP,
  BASIC_VALUE_TOOLTIP,
  BASIC_VARIABLE_TOOLTIP,
  ComponentConfigType,
} from '../../utils';

export const config: IConfig = {
  component: ComponentType.CompareWorkspaceCustomPanel,
  configGroups: [
    {
      title: 'Component Properties',
      items: [
        {
          name: 'header',
          label: 'Header',
          valueComponent: { type: 'Input' },
          configTypes: [
            ComponentConfigType.Variable,
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
            ComponentConfigType.Translate,
          ],
          tooltips: [
            { key: ComponentConfigType.Variable, value: BASIC_VARIABLE_TOOLTIP },
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            { key: ComponentConfigType.JsonLogic, value: BASIC_JSON_LOGIC_TOOLTIP },
            { key: ComponentConfigType.Translate, value: BASIC_TANSLATE_TOOLTIP },
          ],
        },
      ],
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
